import { render, staticRenderFns } from "./DealMethodsCard.vue?vue&type=template&id=21892a14&scoped=true"
import script from "./DealMethodsCard.vue?vue&type=script&lang=js"
export * from "./DealMethodsCard.vue?vue&type=script&lang=js"
import style0 from "./DealMethodsCard.vue?vue&type=style&index=0&id=21892a14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21892a14",
  null
  
)

export default component.exports